import axios from "axios";

const getPasswordPolicy = () => axios.get(`/personal/api/v1/profile/password_policy`);

export default {
  getPasswordPolicy
};
